<template>
  <popup :close-action="closeModal">
    <template v-slot:title>
      <div class="title">
        לא הצלחת להיכנס לשירות?
      </div>
    </template>
    <template v-slot:content>
      <div class="text">
        צריך רק למלא את הפרטים והצוות שלנו ייצור איתך קשר בהקדם האפשרי כדי לפתור את הבעיה.
      </div>
      <div class="form">
        <text-input
          :autofocus="true"
          :labelText="'שם מלא'"
          :on-input="nameEntered"
          :value="fullName"
          :error="nameError.length > 0"
          :top-left-label="nameError"
        />
        <text-input
          :labelText="'מספר טלפון'"
          :on-input="numberEntered"
          :value="phoneNumber"
          :inputType="'text'"
          :inputPattern="'\\d*'"
          :error="phoneError.length > 0"
          :top-left-label="phoneError"
        />
        <text-input
          :labelText="'סיבת הפניה'"
          :on-input="reasonEntered"
          :value="reason"
          :inputType="'text'"
          :inputPattern="'.+'"
          :error="reasonError.length > 0"
          :top-left-label="reasonError"
        />
      </div>
      <div v-if="messageSent" class="message-sent">
        תודה, נחזור אליך בהקדם!
      </div>
      <riseup-button v-else
                     class="done-btn"
                     :action="() => submit()"
                     :title="'שליחה'"/>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import LoginApi from '../../../../../api/LoginApi';
import DDLogs from '../../../../../DDLogs';

export default {
  name: 'LoginHelp',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    textInput: BaseUI.TextInput,
    Popup: BaseUI.Popup,
  },
  data() {
    return {
      fullName: '',
      phoneNumber: '',
      nameError: '',
      phoneError: '',
      messageSent: false,
      reason: '',
      reasonError: '',
    };
  },
  computed: {
    hasErrors() {
      return this.nameError || this.phoneError || this.reasonError;
    },
  },
  methods: {
    async closeModal() {
      this.$emit('close');
    },
    async submit() {
      this.resetErrors();
      this.validateName();
      this.validateNumber();
      this.validateReason();
      const customerDetails = { phoneNumber: this.phoneNumber, fullName: this.fullName, reason: this.reason };
      if (!this.hasErrors) {
        try {
          await LoginApi.loginHelpLead(customerDetails);
          this.replaceButton();
        } catch (error) {
          DDLogs.error('Customer needs help logging in but lead creation failed', customerDetails);
          this.replaceButton();
          throw new Error(`Customer needs help logging in but lead creation failed [name=${this.fullName}] [number=${this.phoneNumber}]`);
        }
      }
    },
    resetErrors() {
      this.nameError = '';
      this.phoneError = '';
      this.reasonError = '';
    },
    validateName() {
      if (this.fullName.length < 2) {
        this.nameError = 'צריך להכניס שם מלא';
      }
    },
    validateNumber() {
      if (!this.phoneNumber.match(/^0[0-9]{9}$/)) {
        this.phoneError = 'מספר הטלפון לא תקין';
      }
    },
    validateReason() {
      if (this.reason.length === 0) {
        this.reasonError = 'צריך להכניס את סיבת הפניה';
      }
    },
    nameEntered(value) {
      this.nameError = '';
      this.fullName = value;
    },
    numberEntered(value) {
      this.phoneError = '';
      this.phoneNumber = value;
    },
    reasonEntered(value) {
      this.reasonError = '';
      this.reason = value;
    },
    replaceButton() {
      this.messageSent = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .title {
    font-size: 24px;
    font-weight: bold;
  }

  .text {
    margin: 30px 0px;
    font-size: 16px;
    line-height: 22px;
  }

  .done-btn {
    margin-top: 25px;
    width: 100%;
  }

  .message-sent {
    padding: 15px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: $riseup_blue;
  }
</style>
